import { SeriousAboutTalent } from "@/ui/SeriousAboutTalent";
import { useLocale } from "@/hooks/useLocale";
import Image from "@/ui/Image";
import { Col } from "react-bootstrap";
import YoutubeVideoModal from "@/ui/YoutubeVideoModal";
import { getGlobal } from "@/functions/getGlobal";
import { stripTags } from "@/functions/stripTags";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import React from "react";

export const DiversityPageProgrammeOneSection = ({ className, pathPrefix }) => {
  const locale = useLocale();
  const global = getGlobal();

  return (
    <SeriousAboutTalent
      className={className}
      title={`${pathPrefix}.title.${locale}`}
      text={`${pathPrefix}.text.${locale}`}
    >
      <Col xs={12} lg={6}>
        {/* START: CMS Tools editable fix */}
        <SourceFlowText
          global={global}
          path={`${pathPrefix}.video.${locale}`}
          type="text"
          className="visually-hidden"
        />
        {/* END: CMS Tools editable fix */}
        <YoutubeVideoModal video_embed_url={stripTags(global[`${pathPrefix}.video.${locale}`]).trim()}>
          <div className="ratio ratio-4x3 mt-4">
            <Image
              img={{
                path: `${pathPrefix}.image`,
                src: "/assets/diversity/content/1.jpg",
              }}
              size="622x"
              alt=""
              style={{ objectFit: "cover", objectPosition: "center right" }}
            />
          </div>
        </YoutubeVideoModal>
      </Col>
    </SeriousAboutTalent>
  );
};

DiversityPageProgrammeOneSection.defaultProps = {
  className: "py-4 py-md-5",
  pathPrefix: "page.diversity.programme.one",
};
